import { Flame, Github, Linkedin } from "lucide-react";
import links from "../data/links";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/10 bg-[#050505] py-14 px-6 lg:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="flex items-center gap-4">
            <span className="w-10 h-10 border border-[#FF4D00]/60 flex items-center justify-center text-[#FF4D00]">
              <Flame className="w-4 h-4 flicker" />
            </span>
            <div>
              <div className="font-mono text-[11px] tracking-[0.32em] text-neutral-400">
                PROMETHEUS<span className="text-[#FF4D00]">·</span>EBM
              </div>
              <div className="font-serif-display italic text-[14px] text-neutral-500 mt-1 whitespace-nowrap">
                Built with quiet obsession by Mushfiqul Alam — a solitary scholar of the digital loom.
              </div>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <a
              href={links.github_profile}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-github"
              className="w-10 h-10 border border-white/10 hover:border-[#FF4D00]/60 flex items-center justify-center text-neutral-400 hover:text-[#FF4D00] transition-colors"
              aria-label="GitHub"
            >
              <Github className="w-4 h-4" />
            </a>
            <a
              href={links.linkedin}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-linkedin"
              className="w-10 h-10 border border-white/10 hover:border-[#00F0FF]/60 flex items-center justify-center text-neutral-400 hover:text-[#00F0FF] transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-4 h-4" />
            </a>
            <a
              href={links.pypi}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-pypi"
              className="font-mono text-[12px] tracking-[0.22em] uppercase border border-[#FF4D00]/60 text-[#FF4D00] px-4 py-2.5 hover:bg-[#FF4D00]/10 transition-colors whitespace-nowrap"
            >
              pip install prometheus-ebm
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3 font-mono text-[10px] tracking-[0.3em] text-neutral-600 uppercase">
          <span>© 2026 · Mushfiqul Alam · All rights reserved.</span>
          <span>
            the fire was stolen · not borrowed
          </span>
        </div>
      </div>
    </footer>
  );
}
